import classNames from 'classnames';
import { ButtonHTMLAttributes, FC } from 'react';

import { FilterAttribute } from '@/shared/config';
import { Bullet, Icon } from '@/shared/ui';

import styles from './toggleMobileFilters.module.scss';

interface ToggleMobileFiltersProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  filters: FilterAttribute[];
  className?: string;
}

const ToggleMobileFilters: FC<ToggleMobileFiltersProps> = (props) => {
  const { filters = [], className, ...rest } = props;
  const count =
    filters?.reduce((acc, item) => acc + item.values.length, 0) ?? 0;
  return (
    <button className={classNames(styles.container, className)} {...rest}>
      {count > 0 && <Bullet count={count} variant="border-black-24" />}
      Фильтры
      <Icon name="chevron" size={20} />
    </button>
  );
};

export default ToggleMobileFilters;
